/**
 * Телефон для показа.
 *
 * ⚠️ ЕДИНСТВЕННАЯ ЧЕЛОВЕЧЕСКАЯ СТРОКА ЭТОГО ДОМЕНА, КОТОРУЮ СПЕКА ОСТАВИЛА ФРОНТУ (§7): сервис
 * хранит канонический E.164 (`+79161112233`), «форматирование для показа — на стороне UI». Всё
 * прочее человеческое — подписи типов, происхождений, дат, счётчиков — приходит с сервера, и
 * заводить здесь второй такой источник нельзя.
 */

/** Российский мобильный в E.164. Только он и разбирается на группы — см. `formatPhone`. */
const RU_MOBILE = /^\+7(\d{3})(\d{3})(\d{2})(\d{2})$/

/**
 * `+79182441907` → `+7 918 244-19-07`.
 *
 * Всё, что не подошло под российский мобильный, возвращается КАК ЕСТЬ. Это не лень: у гостя может
 * быть номер любой страны, а группировка цифр в них разная (у +49 и +1 она другая), и «улучшить»
 * чужой номер своей маской значит показать менеджеру то, чего он не набирал. Пустая строка тоже
 * проходит насквозь — телефона у гостя может не быть вовсе.
 */
export function formatPhone(value: string): string {
  const match = RU_MOBILE.exec(value)
  return match ? `+7 ${match[1]} ${match[2]}-${match[3]}-${match[4]}` : value
}

/**
 * Значение канала для показа. Телефон форматируем, ник и числовой id — нет.
 *
 * Решаем по САМОМУ значению, а не по типу канала: тип — открытая строка (сервер вправе прислать
 * незнакомый), и ветка «а телефон ли это» по списку типов промахнулась бы ровно на новом типе.
 * У E.164 форма опознаётся однозначно: плюс и дальше только цифры.
 */
export function formatContactValue(value: string): string {
  return /^\+\d+$/.test(value) ? formatPhone(value) : value
}
